<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6JIkGb/cover.jpg?1699583446260" alt="This image is the cover for the book Corsican Death, The Narc Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Corsican Death, The Narc Series
      </h1>
      <p class="bookDescription body article font2">
        <p class="MsoNormal"><b>With a handful of agents, Bolt takes on the crown prince of European smuggling</b></p><p class="MsoNormal">Two French businessmen come to the United States to arrange an export deal. Normally the federal government would have no interest, but these Frenchmen are Corsican, and their product is the finest heroin in the world. For months the crime syndicate overseen by Count Napoleon Bonaparte Lonzu has stockpiled its smack, creating a worldwide shortage and sending demand through the roof. Now it is time to open the floodgates, and dump a colossal shipment of white heroin onto the United States. But the deal goes sour from the very start. </p><p class="MsoNormal"></p><p class="MsoNormal">Lanzu’s lieutenants run into John Bolt, a narcotics agent who makes the toughest Corsicans wilt. He only has a handful of operatives in his critically underfunded anti-drug detail, but Bolt will crack the Corsican syndicate if he has to cross the Atlantic to do it. Count Lanzu may have an army, but next to a determined American cop, every Napoleon looks small.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Olden
      </h2>
      
      <p class="authorDescription body article">Marc Olden (1933&ndash;2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book,&#160;<I>Angela Davis</I>&#160;(1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published&#160;<I>Narc</I>, under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent.<P>A year later,&#160;<I>Black Samurai</I>&#160;introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden&rsquo;s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cfcdc92e